// extracted by mini-css-extract-plugin
module.exports = {"ratio_box":"FJResourcesRatioBox_ratio_box__1i57m","ratio_title":"FJResourcesRatioBox_ratio_title__3gzT4","ratio_list":"FJResourcesRatioBox_ratio_list__3hTfR"};